import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

const Selector = ({
  name,
  options,
  helperText,
  fullWidth,
  placeHolder,
  required,
  variant,
  defaultValue,
  onChange,
  ...properties
}) => {
  const [value, setValue] = useState(defaultValue);

  const updateSelected = (event) => {
    onChange(event);
    const value = event && event.target ? event.target.value : '';
    setValue(value);
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [options, defaultValue]);

  return (
    <>
      <FormControl
        sx={{ minWidth: 120 }}
        fullWidth={fullWidth}
        variant={variant}
      >
        <InputLabel id={`selector-helper-label-${name}`}>
          {placeHolder ? (required ? `${placeHolder} *` : placeHolder) : ''}
        </InputLabel>
        <Select
          labelId={`selector-helper-label-${name}`}
          id={name}
          name={name}
          value={value}
          label={
            placeHolder ? (required ? `${placeHolder} *` : placeHolder) : ''
          }
          onChange={(event) => updateSelected(event)}
          {...properties}
        >
          {options ? (
            options.map((option, index) => (
              <MenuItem
                key={option.id ? option.id : index}
                value={option.value}
                disabled={!!option.disabled}
              >
                {option.text}
              </MenuItem>
            ))
          ) : (
            <></>
          )}
        </Select>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>
    </>
  );
};

Selector.propTypes = {
  name: PropTypes.string,
  options: PropTypes.array,
  helperText: PropTypes.string,
  fullWidth: PropTypes.bool,
  placeHolder: PropTypes.string,
  required: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  variant: PropTypes.string,
};

Selector.defaultProps = {
  name: `defaultSelectorName-${Date.now()}`,
  options: [],
  helperText: '',
  fullWidth: false,
  placeHolder: '',
  required: false,
  defaultValue: '',
  onChange: () => {},
  variant: 'standard',
};

export default Selector;
